import { Button } from 'antd';
import { LatLngExpression } from 'leaflet';
import React from 'react';
import { TileLayer, Marker, MapContainer } from 'react-leaflet';
import { PREVIEW_DEFAULT_ZOOM, tileLayerSetCartodb, tileLayerCartoVoyager, tileLayerCartoPositronLight } from '../util/MapHelpers';
import { EnvironmentOutlined } from '@ant-design/icons';

interface Props {
  initPosition: LatLngExpression | undefined;
  handleButtonClick: () => void;
  mapLoading?: boolean;
  buttonText?: string;
  buttonSize?: 'small' | 'middle' | 'large';
  buttonType?: 'default' | 'primary' | 'dashed' | 'link' | 'text';
  preview_type?: 'small' | 'large';
  previewInitZoom?: number;
}

const MapStaticPreview: React.FC<Props> = ({
  initPosition,
  handleButtonClick,
  mapLoading = false,
  buttonText = 'Map View',
  buttonSize = 'middle',
  buttonType = 'primary',
  preview_type,
  previewInitZoom = PREVIEW_DEFAULT_ZOOM,
}: Props) => {
  return (
    <div className={`map-static-preview-placeholder ${preview_type || "" }`}>
      <div
        className={`map-static-preview`}
      >
        <MapContainer
          center={initPosition}
          zoom={previewInitZoom}
          className="map-container-static"
          zoomControl={false}
          dragging={false}
          doubleClickZoom={false}
          scrollWheelZoom={false}
        >
          <TileLayer {...tileLayerCartoVoyager} />
          {initPosition && <Marker position={initPosition} />}
          <Button
            type={buttonType}
            size={buttonSize}
            icon={<EnvironmentOutlined />}
            onClick={handleButtonClick}
            loading={mapLoading}
            className="map-preview-button"
          >
            {buttonText}
          </Button>
        </MapContainer>
      </div>
    </div>
  );
};

export default MapStaticPreview;
